import './bootstrap';

const scrollCapsule = () => {
    document.querySelectorAll('.scroll-capsule-host').forEach((host) => {
        const isPage = host.dataset.pageScroll === 'true';
        const viewportHeight = isPage ? window.innerHeight : host.clientHeight;
        const contentHeight = isPage ? document.documentElement.scrollHeight : host.scrollHeight;
        const currentTop = isPage ? window.scrollY : host.scrollTop;
        const canScrollY = contentHeight > viewportHeight + 1;
        const canScrollX = !isPage && host.scrollWidth > host.clientWidth + 1;
        host.dataset.scrollY = canScrollY;
        host.dataset.scrollX = canScrollX;

        ['y', 'x'].forEach((axis) => {
            let indicator = host.querySelector(`:scope > .scroll-capsule-indicator[data-axis="${axis}"]`);
            const canScroll = axis === 'y' ? canScrollY : canScrollX;

            if (canScroll && !indicator) {
                indicator = document.createElement('span');
                indicator.className = 'scroll-capsule-indicator';
                indicator.dataset.axis = axis;
                indicator.setAttribute('aria-hidden', 'true');
                host.appendChild(indicator);
            }

            if (!indicator) return;

            const viewport = axis === 'y' ? viewportHeight : host.clientWidth;
            const content = axis === 'y' ? contentHeight : host.scrollWidth;
            const scroll = axis === 'y' ? currentTop : host.scrollLeft;
            const track = Math.max(viewport - 8, 0);
            const size = Math.max(16, Math.min(40, track * viewport / content));
            const offset = content > viewport ? (track - size) * scroll / (content - viewport) : 0;
            host.style.setProperty('--capsule-size', `${size}px`);
            host.style.setProperty('--capsule-offset', `${offset}px`);

            if (!indicator.dataset.dragBound) {
                indicator.dataset.dragBound = 'true';
                indicator.addEventListener('pointerdown', (event) => {
                    event.preventDefault();
                    indicator.setPointerCapture(event.pointerId);
                    indicator.dataset.dragging = 'true';
                    host.classList.add('is-dragging');
                });
                indicator.addEventListener('pointermove', (event) => {
                    if (indicator.dataset.dragging !== 'true') return;

                    indicator._dragPoint = event;
                    if (indicator._dragFrame) return;
                    indicator._dragFrame = requestAnimationFrame(() => {
                        const dragEvent = indicator._dragPoint;
                        const isVertical = indicator.dataset.axis === 'y';
                        const viewportSize = isVertical
                            ? (isPage ? window.innerHeight : host.clientHeight)
                            : host.clientWidth;
                        const contentSize = isVertical
                            ? (isPage ? document.documentElement.scrollHeight : host.scrollHeight)
                            : host.scrollWidth;
                        const trackSize = Math.max(viewportSize - 8, 0);
                        const capsuleSize = Math.max(16, Math.min(40, trackSize * viewportSize / contentSize));
                        const bounds = isPage ? { top: 0, left: 0 } : host.getBoundingClientRect();
                        const pointer = isVertical ? dragEvent.clientY - bounds.top : dragEvent.clientX - bounds.left;
                        const position = Math.max(0, Math.min(trackSize - capsuleSize, pointer - capsuleSize / 2));
                        const scroll = trackSize > capsuleSize
                            ? position / (trackSize - capsuleSize) * (contentSize - viewportSize)
                            : 0;

                        if (isVertical && isPage) window.scrollTo(0, scroll);
                        else if (isVertical) host.scrollTop = scroll;
                        else host.scrollLeft = scroll;
                        indicator._dragFrame = null;
                        scrollCapsule();
                    });
                });
                ['pointerup', 'pointercancel'].forEach((eventName) => {
                    indicator.addEventListener(eventName, (event) => {
                        indicator.dataset.dragging = 'false';
                        host.classList.remove('is-dragging');
                        if (indicator._dragFrame) {
                            cancelAnimationFrame(indicator._dragFrame);
                            indicator._dragFrame = null;
                        }
                        if (indicator.hasPointerCapture(event.pointerId)) indicator.releasePointerCapture(event.pointerId);
                    });
                });
            }
        });
    });
};

const prepareScrollCapsules = (root = document) => {
    if (root === document) {
        document.documentElement.classList.add('scroll-capsule-host');
        document.documentElement.dataset.pageScroll = 'true';
    }
    root.querySelectorAll?.('*').forEach((element) => {
        if (element.matches('.scroll-capsule-indicator')) return;
        const style = getComputedStyle(element);
        const scrollable = ['auto', 'scroll'].includes(style.overflowY) || ['auto', 'scroll'].includes(style.overflowX);
        if (scrollable) element.classList.add('scroll-capsule-host');
    });
    scrollCapsule();
};

document.addEventListener('DOMContentLoaded', () => {
    prepareScrollCapsules();
    window.addEventListener('resize', scrollCapsule, { passive: true });
    document.addEventListener('scroll', scrollCapsule, { passive: true, capture: true });

    new MutationObserver((mutations) => {
        mutations.forEach(({ addedNodes }) => addedNodes.forEach((node) => {
            if (node.nodeType === Node.ELEMENT_NODE) prepareScrollCapsules(node);
        }));
    }).observe(document.body, { childList: true, subtree: true });
});
